<template>
  <div
    v-if="items.length"
    class="review-card-supplements d-flex flex-column ga-2"
    data-qa="review_card_supplements"
  >
    <div
      v-for="(supplement, index) in items"
      :key="supplement.dt_created || index"
      class="review-card-supplements__item text--text pa-4"
      data-qa="review_card_supplement"
    >
      <div
        class="text-subtitle-2 mb-2"
        data-qa="review_card_supplement_date"
      >
        {{ tStatic('Дополнение от') }} {{ formatSupplementDate(supplement.dt_created, languageIso) }}
      </div>
      <div
        class="text-body-2"
        :class="{ 'review-card-supplements__text--truncated': truncated }"
        data-qa="review_card_supplement_text"
      >
        {{ getSupplementHtml(supplement) }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import type { CommonContextStore } from 'src/types/context'
import useContextStore from 'src/store/useContextStore'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import type { RateSupplement } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/types'
import { formatSupplementDate } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/functions/formatReviewDates'
import { getSupplementHtml } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/functions/getCommentHtml'

withDefaults(defineProps<{
  items: RateSupplement[]
  truncated?: boolean
}>(), {
  truncated: false,
})

const { context }: CommonContextStore = useContextStore()
const languageIso = computed(() => context.current_language.iso)
</script>

<style scoped lang="scss">
@import '~www/themes/doctors/common/variables';

.review-card-supplements {
  &__item {
    background-color: $ui-kit-bg-secondary;
    border-radius: $border-radius-sm;
  }

  &__text--truncated {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 5;
  }
}
</style>
